export default "__VITE_ASSET__BcOXuNnI__"